import { z } from "zod";

import { constantsData } from "@/data";

export const reconciliationsFormSchema = z.object({
    dataSourceA: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    dataSourceB: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    exceptionConScoreThreshold: z.string().transform((val) => Number(val)).refine(
        (val) => val >= 0 && val <= 0.49,
        { message: constantsData.msgs.notValidConfidenceScores },
    ),
    frequency: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    id: z.string().optional(),
    inReviewConScoreThreshold: z.string().transform((val) => Number(val)).refine(
        (val) => val >= 0.5 && val <= 1,
        { message: constantsData.msgs.notValidConfidenceScores },
    ),
    matchedConScoreThreshold: z.string().transform((val) => Number(val)).refine(
        (val) => val >= 0.8 && val <= 1,
        { message: constantsData.msgs.notValidConfidenceScores },
    ),
    name: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    rules: z.string().optional(),
}).refine(
    (data) => data.matchedConScoreThreshold > data.inReviewConScoreThreshold && data.inReviewConScoreThreshold > data.exceptionConScoreThreshold,
    {
        message: constantsData.msgs.notValidConfidenceScores,
        path: ["matchedConScoreThreshold"],
    },
);
